import { Options, SetOptionsPayload } from '@checkout/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { OPTIONS } from '../checkout-state';

export const LOAD_OPTIONS = '[Checkout] Load options';
export const LOAD_OPTIONS_FAIL = '[Checkout] Load options Fail';
export const LOAD_OPTIONS_SUCCESS = '[Checkout] Load options Success';
export const LOAD_OPTIONS_RESET = '[Checkout] Load options Reset';

export const SET_OPTIONS = '[Checkout] Set options';

export class LoadOptions extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_OPTIONS;

  constructor() {
    super(OPTIONS);
  }
}

export class LoadOptionsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_OPTIONS_FAIL;

  constructor(public payload: any) {
    super(OPTIONS, payload);
  }
}

export class LoadOptionsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_OPTIONS_SUCCESS;

  constructor(public payload: Options) {
    super(OPTIONS);
  }
}

export class ResetOptions extends StateUtils.LoaderResetAction {
  readonly type = LOAD_OPTIONS_RESET;

  constructor() {
    super(OPTIONS);
  }
}

export class SetOptions implements Action {
  readonly type = SET_OPTIONS;

  constructor(public payload: SetOptionsPayload) {}
}

export type OptionsActions = LoadOptions | LoadOptionsSuccess | LoadOptionsFail | SetOptions;
